














































































































































































































































































































































































































































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import dayjs from 'dayjs'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { MaterialServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import {
  StockOutTypeServiceProxy,
  StockOutOrderServiceProxy,
  StockOutPlanServiceProxy,
  StockOutPlanMaterialServiceProxy
} from '@/service-proxies/app-v2/wms.service-proxies'
import {
  WarehouseMaterialStockServiceProxy,
  WarehouseAreaServiceProxy
} from '@/service-proxies/app-v2/warehouse.service-proxies'
import _ from 'lodash'
import {
  PlanMaterialServiceProxy,
  ProductionOrderServiceProxy,
  ProductionPlanServiceProxy
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'

const sopmsp = new StockOutPlanMaterialServiceProxy()
const sopsp = new StockOutPlanServiceProxy()
const whasp = new WarehouseAreaServiceProxy()
const msp = new MaterialServiceProxy()
const sotsp = new StockOutTypeServiceProxy()
const whmssp = new WarehouseMaterialStockServiceProxy()
const soosp = new StockOutOrderServiceProxy()
const ppsp = new ProductionPlanServiceProxy()
const pmsp = new PlanMaterialServiceProxy()
const csp = new CustomerServiceProxy()
const posp = new ProductionOrderServiceProxy()
const crsp = new CodeRuleServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'key',
    scopedSlots: { customRender: 'key' },
    width: 100,
    ellipsis: true,
    fixed: 'left'
  },
  {
    title: 'page_material_warehousing_material_bar',
    dataIndex: 'barCode',
    scopedSlots: { customRender: 'barCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_area',
    dataIndex: 'areaId',
    scopedSlots: { customRender: 'areaId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_location',
    dataIndex: 'locationId',
    scopedSlots: { customRender: 'locationId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_specifications',
    dataIndex: 'materialStandardModel',
    scopedSlots: { customRender: 'materialStandardModel' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_1',
    dataIndex: 'materialStuff',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_unit',
    dataIndex: 'materialUnit',
    scopedSlots: { customRender: 'materialUnit' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_demand_quantity',
    dataIndex: 'requireNum',
    scopedSlots: { customRender: 'requireNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_plan_quantity',
    dataIndex: 'planNum',
    scopedSlots: { customRender: 'planNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_out_stockNum',
    dataIndex: 'stockNum',
    scopedSlots: { customRender: 'stockNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_out_stockOutNum',
    dataIndex: 'stockOutNum',
    scopedSlots: { customRender: 'stockOutNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_remark',
    dataIndex: 'remark',
    ellipsis: true,
    scopedSlots: { customRender: 'remark' }
  }
]
export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      dayTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      count: 1,
      dataSource: [],
      cacheData: [],
      editingKey: '',
      materialList: [], // 物料列表
      materialAddList: [],
      OutTypeList: [], // 出库类型
      areaList: [], // 库区列表
      locationList: [], // 库位列表
      loading: false,
      isPlan: false,
      planList: [], // 计划列表
      outTypeCode: '',
      selectPlan: '',
      planInfo: {},
      customerList: [], // 客户列表
      orderList: [], // 工单列表
      selectOrder: '',
      processList: [], // 工序列表
      selectProcess: '',
      codeList: [],
      codeRuleId: '',
      codeRule: undefined,
      distributeUserName: '',
      produceDeptName: '',
      value: '',
      type: 0,
      deliveryList: [],
      stockOutPlanCode: '',
      hasOutPlan: false
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    areaId: {
      type: String,
      default: ''
    },
    listWare: {
      type: Array,
      default: () => []
    },
    employeesList: {
      type: Array,
      default: () => []
    },
    treeList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['materialPointDetail']),
    columns() {
      return columns.map((item) => {
        if (this.hasOutPlan && this.outTypeCode === 'materialStockOut') {
          if (item.dataIndex === 'requireNum') {
            item.dataIndex = 'toBeDeliveredNum'
            item.scopedSlots = { customRender: 'toBeDeliveredNum' }
          }
        } else {
          if (item.dataIndex === 'toBeDeliveredNum') {
            item.dataIndex = 'requireNum'
            item.scopedSlots = { customRender: 'requireNum' }
          }
        }
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getALLMaterial()
          sotsp.getStockOutTypeList().then((res) => {
            this.OutTypeList = res
          })
          csp.getPageCustomer(undefined,1, '', 9999).then((res) => {
            this.customerList = res.records
          })
        }
      }
    }
  },
  created() {
    this.getList()
    this.getALLMaterial()
    sotsp.getStockOutTypeList().then((res) => {
      this.OutTypeList = res
    })
    csp.getPageCustomer(undefined,1, '', 9999).then((res) => {
      this.customerList = res.records
    })
  },
  methods: {
    ...mapActions('app', ['saveMaterialPoint']),
    disabledMater(record) {
      console.log(record.key)
      return (
        (this.outTypeCode != 'processedStockOut' ||
          this.outTypeCode != 'orderStockOut' ||
          this.outTypeCode != 'sparePartsStockOut') &&
        record.key.indexOf('edit') === -1
      )
    },
    selectCodeRule(value) {
      this.form.setFieldsValue({
        orderCode: ''
      })
      this.codeRule = value
    },
    getPlanList() {
      const values: any = {
        typeId: null,
        filterPlus: false,
        planStatus: ['1', '2', '3', '4', '6'],
        param: {}
      }
      ppsp.page(1, values, 9999).then((res) => {
        this.planList = res.records
      })
    },
    getMaterialPlanList() {
      whasp.getTpmRepairAndMaintainNumber().then((res) => {
        this.planList = res
      })
    },
    handleDistributeUserName(val) {
      let person = this.employeesList.find((items) => items.id === val)
      if (person && person.hasOwnProperty('name')) this.distributeUserName = person.name
    },
    handleReceivingDeptName(val) {
      this.value = val
      this.treeList.find((item) => {
        this.forName(item)
      })
    },
    forName(item) {
      if (item.value === this.value) this.produceDeptName = item.title
      if (item && item.hasOwnProperty('children'))
        if (item.children.length > 0)
          item.children.find((items) => {
            this.forName(items)
          })
    },
    async getList() {
      let result = await crsp.list('StockOutObject')
      this.codeList = result.map((item) => ({ label: item.name, value: item.id }))
    },
    changeLocationList(value, record) {
      whmssp
        .listLocationByMaterialIdAndAreaId(this.areaId, value, record.materialId)
        .then((res) => {
          this.locationList = res
        })
    },
    changeMaterialList(value) {
      if (this.outTypeCode === 'sparePartsStockOut') {
        this.getSpareMaterialList(value)
      } else {
        if (this.selectPlan && this.outTypeCode && this.outTypeCode === 'processedStockOut') {
          msp.getMaterialList(2, value, 2, '').then((res) => {
            this.materialList = res
          })
        } else {
          whmssp.listAllMaterial(this.areaId, value).then((res) => {
            this.arrangementMaterial(res)
          })
        }
      }
    },
    getALLMaterial() {
      whmssp.listAllMaterial(this.areaId, '').then((res) => {
        this.arrangementMaterial(res)
      })
    },
    arrangementMaterial(res) {
      this.materialList = res
      this.materialList.map((item) => {
        if (item.standardModel) {
          item.displayCode = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})——${item.standardModel}(${this.$t('page_material_warehousing_specifications')})`
        } else {
          item.displayCode = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})`
        }
      })
    },
    moment,
    // 关联计划
    changePlan(value) {
      this.editingKey = ''
      this.dataSource = []
      this.cacheData = []
      this.selectPlan = ''
      if (value.target.value === 1) {
        this.isPlan = true
        if (this.selectPlan && this.outTypeCode) {
          this.getMaterialList()
        }
      } else {
        this.isPlan = false
        this.form.setFieldsValue({
          planCode: '',
          processCode: '',
          orderCode: '',
          workOrderCode: '',
          stockOutPlanId: ''
        })
        this.stockOutPlanCode = ''
        this.hasOutPlan = false
        this.deliveryList = []
        this.getALLMaterial()
      }
    },
    handleChangeStock(value) {
      this.editingKey = ''
      this.dataSource = []
      this.cacheData = []
      this.selectPlan = ''
      this.form.setFieldsValue({
        planCode: '',
        processCode: '',
        orderCode: '',
        workOrderCode: '',
        stockOutPlanId: ''
      })
      this.stockOutPlanCode = ''
      this.hasOutPlan = false
      this.deliveryList = []
      const data = this.OutTypeList.find((res) => res.id == value)
      this.outTypeCode = data ? data.code : ''
      if (this.selectPlan && this.outTypeCode) {
        this.getMaterialList()
      }
      if (this.outTypeCode === 'sparePartsStockOut') {
        this.getMaterialPlanList()
      } else {
        this.getPlanList()
      }
    },

    handleChangePlan(value) {
      this.editingKey = ''
      this.dataSource = []
      this.cacheData = []
      this.selectPlan = value
      if (this.outTypeCode === 'orderStockOut') {
        this.form.setFieldsValue({
          planCode: '',
          orderCode: '',
          workOrderCode: ''
        })
        this.stockOutPlanCode = ''
        this.hasOutPlan = false
        this.deliveryList = []
        this.selectOrder = ''
        this.selectProcess = ''
      }
      if (this.selectPlan && this.outTypeCode) {
        if (this.outTypeCode === 'processedStockOut') {
          const plan = this.planList.find((res) => res.code === this.selectPlan)
          if (plan) {
            posp.orderLis(plan.id).then((res) => {
              this.orderList = res
            })
          }
        }
        if (this.outTypeCode === 'sparePartsStockOut') {
          this.getSpareMaterialList('')
        } else if (this.outTypeCode === 'materialStockOut') {
          this.form.setFieldsValue({
            stockOutPlanId: ''
          })
          this.stockOutPlanCode = ''
          this.hasOutPlan = false
          this.deliveryList = []
          this.getDeliveryList(this.selectPlan)
          this.getMaterialList()
        } else {
          this.getMaterialList()
        }
      }
    },
    async getDeliveryList(value) {
      const plan = this.planList.find((res) => res.code === value)
      this.deliveryList = []
      if (plan) {
        const res = await sopsp.listStockOutPlanByPlanId(plan.id)
        this.deliveryList = res
      }
    },
    async handleChangeDelivery(value) {
      this.dataSource = []
      this.cacheData = []
      const stock = this.deliveryList.find((res) => res.id === value)
      this.stockOutPlanCode = stock.code
      this.hasOutPlan = true
      const res = await sopmsp.listStockOutPlanMaterial(value)
      const area = this.listWare.find((res) => res.id === this.areaId)
      console.log(area)
      this.dataSource = res.map((item, index) => {
        const dat = {
          ...item
        }
        dat['key'] = index + 'edit'
        dat['areaId'] = this.areaId
        dat['areaName'] = area.name
        return dat
      })
      this.cacheData = res.map((item, index) => {
        const dat = {
          ...item
        }
        dat['key'] = index + 'edit'
        dat['areaId'] = this.areaId
        dat['areaName'] = area.name
        return dat
      })
    },
    getSpareMaterialList(value) {
      whmssp.listAllMaterialForParts(this.areaId, value).then((res) => {
        this.arrangementMaterial(res)
      })
    },
    handleChangeOrder(value) {
      this.selectOrder = value
      const order = this.orderList.find((res) => res.code === this.selectOrder)
      if (order) {
        posp.processList(order.id).then((res) => {
          this.processList = res
        })
      }
    },
    handleChangeProcess(value) {
      this.selectProcess = value
    },
    getMaterialList() {
      if (this.outTypeCode === 'processedStockOut') {
        this.dataSource = []
        this.cacheData = []
        msp.getMaterialList(2, '', 2, '').then((res) => {
          this.materialList = res
        })
      } else if (this.outTypeCode === 'orderStockOut') {
        ppsp.productMaterials().then((res) => {
          const data = res.find((value) => value.planCode === this.selectPlan)
          this.planInfo = data
          this.form.setFieldsValue({
            customerId: this.planInfo ? this.planInfo.customerId : '',
            planOrderCode: this.planInfo ? this.planInfo.planOrderCode : ''
          })
          if (data) {
            msp.getMaterialByCode([data.materialCode]).then((res) => {
              if (res && res.length > 0) {
                const area = this.listWare.find((res) => res.id === this.areaId)
                const value = {
                  key: 1 + 'add',
                  id: res[0].id,
                  materialId: res[0].id,
                  barCode: res[0].barCode,
                  materialCode: res[0].code,
                  materialName: res[0].name,
                  areaId: this.areaId,
                  areaName: area.name,
                  locationId: '',
                  locationName: '',
                  materialStandardModel: res[0].standardModel,
                  materialUnit: res[0].unit,
                  stockNum: 0,
                  stockOutNum: 0,
                  materialStuff: res[0].stuff,
                  materialTypeName: res[0].typeName,
                  remark: ''
                }
                this.dataSource = [value]
                this.cacheData = JSON.parse(JSON.stringify(this.dataSource))
              }
            })
          }
        })
      } else {
        const plan = this.planList.find((res) => res.code === this.selectPlan)
        pmsp.materialList('1', plan.id).then((res) => {
          this.dataSource = this.addKey(res, 'add')
          this.cacheData = this.addKey(res, 'add')
        })
      }
    },
    addKey(res, countKey) {
      const data = []
      if (res && res.length > 0) {
        const codes = []
        res.forEach((element, index) => {
          codes.push(element.materialCode)
        })
        msp.getMaterialByCode(codes).then((material) => {
          if (material && material.length > 0) {
            material.forEach((item, index) => {
              const area = this.listWare.find((res) => res.id === this.areaId)
              const planMaterial = res.find((res) => res.materialCode === item.code)
              const value = {
                key: index + countKey,
                id: item.id,
                planMaterialId: planMaterial.id,
                materialId: item.id,
                barCode: item.barCode,
                materialCode: item.code,
                materialName: item.name,
                areaId: this.areaId,
                areaName: area.name,
                locationId: '',
                locationName: '',
                materialStandardModel: item.standardModel,
                materialUnit: item.unit,
                planNum: planMaterial.planNum,
                requireNum: planMaterial.requireNum,
                stockNum: 0,
                stockOutNum: 0,
                bizType: '',
                materialStuff: item.stuff,
                materialTypeName: item.typeName,
                remark: ''
              }
              data.push(value)
            })
          }
        })
      }
      return data
    },
    // 取消关联计划
    handleDelete(sort) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== sort)
    },
    handleChange(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      let num = 0

      if (target) {
        target[column] = value
        this.dataSource = newData
      }
    },
    handleChangeLocationId(value, record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      let num = 0
      let same = false
      newData.forEach((res) => {
        if (res.locationId === value && record.materialId === res.materialId) {
          same = true
        }
      })
      if (same) {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_be_same'))
        return
      }
      whmssp.listWarehouseMaterialStock(value, record.materialId).then((res) => {
        if (res) {
          num = res.length > 0 ? res[0].locationNum : num
          if (target) {
            target['locationId'] = value
            target['stockOutNum'] = 0
            const area = this.locationList.find((res) => res.id === value)
            target['locationName'] = area.name
            target['stockNum'] = num + ''
            this.dataSource = newData
          }
        }
      })
    },
    edit(record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      this.editingKey = record.key
      if (target) {
        const area = this.listWare.find((res) => res.id === this.areaId)
        target['areaId'] = this.areaId
        target['areaName'] = area.name
        target.editable = true
        this.dataSource = newData
      }
    },
    saveTableEdit(key) {
      const newData = [...this.dataSource]
      const newCacheData = [...this.cacheData]
      const target = newData.filter((item) => key === item.key)[0]
      const targetCache = newCacheData.filter((item) => key === item.key)[0]
      if (target.materialId === '') {
        this.$message.warning(this.$t('page_material_warehouse_item_not_selected'))
        return
      }
      if (target.areaId === '') {
        this.$message.warning(this.$t('page_material_warehouse_area_not_selected'))
        return
      }
      if (target.locationId === '') {
        this.$message.warning(this.$t('page_material_warehouse_location_not_selected'))
        return
      }
      if (target.stockOutNum === undefined || target.stockOutNum === null) {
        this.$message.warning(this.$t('page_material_warehouse_quantity_not_filled_in'))
        return
      }
      if (target && targetCache) {
        delete target.editable
        this.dataSource = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
      this.editingKey = ''
    },
    cancelTableEdit(key) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.key)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter((item) => key === item.key)[0])
        delete target.editable
        this.dataSource = newData
      }
    },
    addMaterial() {
      const { count, dataSource } = this
      this.editingKey = count
      const newData = {
        key: count + 'add',
        editable: true,
        id: '',
        materialId: '',
        barCode: '',
        materialCode: '',
        materialName: '',
        areaId: this.areaId,
        areaName: '',
        locationId: '',
        locationName: '',
        materialStandardModel: '',
        materialUnit: '',
        stockNum: 0,
        stockOutNum: 0,
        materialStuff: '',
        materialTypeName: '',
        displayCode: '',
        remark: ''
      }
      this.count = count + 1
      this.dataSource = [...dataSource, newData]
    },
    changeMaterial(value, record) {
      const newData = [...this.dataSource]
      const material = this.materialList.find((res) => res.displayCode === value)
      const checkTarget = newData.find((res) => res.id === material.id)
      if (checkTarget) {
        this.$message.warning(this.$t('page_material_warehouse_cannot_be_selected'))
        return
      }
      const target = newData.find((res) => res.key === record.key)
      const area = this.listWare.find((item) => item.id == this.areaId)
      console.log(area)
      if (area) {
        whmssp.listLocationByMaterialIdAndAreaId(this.areaId, '', material.id).then((res) => {
          this.locationList = res
        })
      }
      if (target) {
        target.id = material.id
        target.displayCode = material.displayCode
        target.materialId = material.id
        target.barCode = material.barCode
        target.materialTypeName = material.typeName
        target.materialCode = material.code
        target.materialName = material.name
        target.isMustCheck = material.isMustCheck
        target.materialStandardModel = material.standardModel
        target.materialStuff = material.stuff
        target.materialUnit = material.unit
        target.areaId = area.id
        target.areaName = area.name
        this.dataSource = newData
        this.cacheData = JSON.parse(JSON.stringify(this.dataSource))
      }
    },
    close() {
      this.reast()
      this.$emit('close')
    },
    save() {
      if (this.editingKey !== '') {
        this.$message.warning(this.$t('page_material_ware_first_save_material'))
        return
      }
      if (this.dataSource && this.dataSource.length < 1) {
        this.$message.warning(this.$t('page_material_ware_first_add_material'))
        return
      }
      let mesg = 0
      this.dataSource.forEach((element, index) => {
        console.log(element)
        if (element.materialId === '') {
          this.$message.warning(this.$t('page_material_warehouse_item_not_selected'))
          mesg = mesg + 1
          return
        }
        if (element.areaId === '') {
          this.$message.warning(this.$t('page_material_warehouse_area_not_selected'))
          mesg = mesg + 1
          return
        }
        if (element.locationId === '') {
          this.$message.warning(this.$t('page_material_warehouse_location_not_selected'))
          mesg = mesg + 1
          return
        }
        if (element.stockOutNum === undefined || element.stockOutNum === null) {
          this.$message.warning(this.$t('page_material_warehouse_quantity_not_filled_in'))
          mesg = mesg + 1
          return
        }
      })
      if (mesg > 0) return
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.isPlan) {
            const plan = this.planList.find((res) => res.code === this.selectPlan)
            if (!plan) {
              this.$message.warning(this.$t('page_plan_choose_plan_no'))
              return
            }
            values.planId = plan.id
            values.stockOutPlanCode = this.stockOutPlanCode
            if (this.outTypeCode === 'processedStockOut') {
              const order = this.orderList.find((res) => res.code === this.selectOrder)
              if (!order) {
                this.$message.warning(this.$t('page_material_ware_select_order'))
                return
              }
              values.workOrderId = order.id
              const process = this.processList.find((res) => res.processCode === this.selectProcess)
              if (!process) {
                this.$message.warning(this.$t('page_material_ware_select_process'))
                return
              }
              values.processCode = this.selectProcess
              values.processId = process.id
              values.processName = process.processName
            }
          }
          this.loading = true
          const list = _.cloneDeep(this.dataSource)
          list.forEach((res) => {
            delete res.id
            delete res.key
          })
          const customer = this.customerList.find((res) => res.id === values.customerId)
          if (customer) {
            values.customerName = customer.name
          }
          values.list = list
          values.stockOutTime = dayjs(values.stockOutTime).format('YYYY-MM-DD HH:mm:ss')
          // if(values.isPlan == 1){
          const person = this.employeesList.find((res) => res.id === values.stockOutUser)
          values.stockOutUserName = person ? person.name : ''
          // }
          const stockIn = this.OutTypeList.find((res) => res.id === values.stockOutTypeId)
          values.stockOutTypeName = stockIn.name
          values.distributeUserName = this.distributeUserName
          values.produceDeptName = this.produceDeptName
          if (this.outTypeCode === 'sparePartsStockOut') {
            const plan = this.planList.find((res) => res.code === this.selectPlan)
            values.bizType = plan ? plan.type : ''
          }
          soosp
            .createOutOrder(values)
            .then(() => {
              this.loading = false
              this.reast()
              this.$message.success(this.$t('page_user_management_new_success'))
              this.$emit('reload')
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    point() {
      if (this.editingKey !== '') {
        this.$message.warning(this.$t('page_material_ware_first_save_material'))
        return
      }
      if (this.dataSource && this.dataSource.length < 1) {
        this.$message.warning(this.$t('page_material_ware_first_add_material'))
        return
      }
      let mesg = 0
      this.dataSource.forEach((element, index) => {
        if (element.materialId === '') {
          this.$message.warning(this.$t('page_material_warehouse_item_not_selected'))
          mesg = mesg + 1
          return
        }
        if (element.areaId === '') {
          this.$message.warning(this.$t('page_material_warehouse_area_not_selected'))
          mesg = mesg + 1
          return
        }
        if (element.locationId === '') {
          this.$message.warning(this.$t('page_material_warehouse_location_not_selected'))
          mesg = mesg + 1
          return
        }
        if (element.stockOutNum === undefined || element.stockOutNum === null) {
          this.$message.warning(this.$t('page_material_warehouse_quantity_not_filled_in'))
          mesg = mesg + 1
          return
        }
      })
      if (mesg > 0) return
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.isPlan) {
            const plan = this.planList.find((res) => res.code === this.selectPlan)
            if (!plan) {
              this.$message.warning(this.$t('page_plan_choose_plan_no'))
              return
            }
            values.planId = plan.id
            values.stockOutPlanCode = this.stockOutPlanCode
            if (this.outTypeCode === 'processedStockOut') {
              const order = this.orderList.find((res) => res.code === this.selectOrder)
              if (!order) {
                this.$message.warning(this.$t('page_material_ware_select_order'))
                return
              }
              values.workOrderId = order.id
              const process = this.processList.find((res) => res.processCode === this.selectProcess)
              if (!process) {
                this.$message.warning(this.$t('page_material_ware_select_process'))
                return
              }
              values.processCode = this.selectProcess
              values.processId = process.id
              values.processName = process.processName
            }
          }
          const list = _.cloneDeep(this.dataSource)
          list.forEach((res) => {
            delete res.id
            delete res.key
          })
          const customer = this.customerList.find((res) => res.id === values.customerId)
          if (customer) {
            values.customerName = customer.name
          }
          values.list = list
          values.stockOutTime = dayjs(values.stockOutTime).format('YYYY-MM-DD HH:mm:ss')
          // if(values.isPlan == 1){
          const person = this.employeesList.find((res) => res.id === values.stockOutUser)
          values.stockOutUserName = person ? person.name : ''
          // }
          const stockIn = this.OutTypeList.find((res) => res.id === values.stockOutTypeId)
          values.stockOutTypeName = stockIn.name
          values.distributeUserName = this.distributeUserName
          values.produceDeptName = this.produceDeptName
          this.loading = true
          soosp
            .createOutOrder(values)
            .then((res) => {
              if (res) {
                this.checkPirnt(res)
              }
              this.loading = false
              this.reast()
              this.$message.success(this.$t('page_user_management_new_success'))
              this.$emit('reload')
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    checkPirnt(res) {
      soosp.getStockOutOrderByCode(res).then((res) => {
        const person = this.employeesList.find((items) => items.id === res.stockOutUser)
        const materialPoint = {
          warehouse: 'out',
          orderCode: res.orderCode,
          code: res.planCode,
          person: person ? person.name : '',
          time: res.stockOutTime ? dayjs(res.stockOutTime).format('YYYY-MM-DD HH:mm:ss') : '',
          list: res.stockOutOrderMaterialVOList
        }
        this.saveMaterialPoint(materialPoint)
        window.open('/material/point', '_blank')
      })
    },
    reast() {
      this.form.resetFields()
      this.count = 1
      this.dataSource = []
      this.cacheData = []
      this.editingKey = ''
      this.materialList = [] // 物料列表
      this.OutTypeList = [] // 出库类型
      this.areaList = [] // 库区列表
      this.locationList = [] // 库位列表
      this.loading = false
      this.isPlan = false
      this.planList = [] // 计划列表
      this.outTypeCode = ''
      this.selectPlan = ''
      this.planInfo = {}
      this.customerList = [] // 客户列表
      this.orderList = [] // 工单列表
      this.selectOrder = ''
      this.processList = [] // 工序列表
      this.selectProcess = ''
      this.stockOutPlanCode = ''
      this.deliveryList = []
    }
  }
})
